import { ContainerModule } from 'inversify';
import { domainModule } from '@framework/config/DI/domainModule';
import { configModule } from '@creditflowresearch/config/DI/configModule';
import { messageManagerModule } from './modules/messageManagerModule';
import { analyticsModule } from '@/creditflowresearch/application/DI/modules/analyticsModule';
import { seoModule } from '@/creditflowresearch/application/DI/modules/seoModule';
import { askAiChatModule } from '@/creditflowresearch/application/DI/modules/askAiChatModule';
import { DispatcherModule as UsersDispatcherModule } from '@users/json-rpc-dispatcher';
import { DispatcherModule as DmPortalDispatcherModule } from '@dm-portal/json-rpc-dispatcher';
import { DmPortalDmPortalDispatcherModule } from '@dm-portal/dm-portal-json-rpc-dispatcher';
import { DispatcherModule as OpenMarketDispatcherModule } from '@openmarket/json-rpc-dispatcher';
import { DispatcherModule as CondorDispatcherModule } from '@condor/json-rpc-dispatcher';
import { DispatcherModule as CfrDispatcherModule } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr';
import {
  DispatcherModule as FinsightStratsDispatcherModule,
} from '@creditflowresearch/json-rpc-dispatcher/dispatcher-finsight-strats';
import { DispatcherModule as CfrInternalDispatcherModule } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr-internal';
import { SocketModule as AskAiSocketModule } from '@creditflowresearch/socket-client/socket-ask-ai-client';
import { SocketModule as FinsightSocketModule } from '@finsight/socket-client';
import { socketConnectionModule } from '@/creditflowresearch/application/DI/modules/socketConnectionModule';
import { FileDownloadLinkGeneratorModule } from '@/creditflowresearch/application/DI/FileDownloadLinkGenerator/FileDownloadLinkGeneratorModule';

export const rootModules: ContainerModule[] = [
  domainModule,
  configModule,
  messageManagerModule,
  analyticsModule,
  seoModule,
  askAiChatModule,
  UsersDispatcherModule,
  DmPortalDispatcherModule,
  DmPortalDmPortalDispatcherModule,
  OpenMarketDispatcherModule,
  CondorDispatcherModule,
  CfrDispatcherModule,
  FinsightStratsDispatcherModule,
  CfrInternalDispatcherModule,
  AskAiSocketModule,
  FinsightSocketModule,
  socketConnectionModule,
  FileDownloadLinkGeneratorModule,
];

export const serverContainerModules = [
  ...rootModules,
];
